import { CommonModule } from '@angular/common';
import { routing } from '@app/modules/carte/carte.routing';
import { RouterModule } from '@angular/router';
import { CarteComponent } from './carte.component';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CarteFamilyComponent } from '@app/components/carte-family/carte-family.component';
import { CarteMenusComponent } from '@app/components/carte-menus/carte-menus.component';
import { CarteFilterComponent } from '@app/components/carte-filter/carte-filter.component';
import { CommonComponentsModule } from '@app/modules/common/common.module';
import { PipesModule } from '@app/pipes/pipes.module';
import { ProductComponent } from '@app/components/product/product.component';
import { MenuComponent } from '@app/components/menu/menu.component';
import { BestOffersComponent } from '@app/components/best-offers/best-offers.component';
import { BestSalesComponent } from '@app/components/best-sales/best-sales.component';

@NgModule({
    imports: [
        CommonComponentsModule,
        CommonModule,
        FormsModule,
        RouterModule,
        routing,
        PipesModule
    ],
    declarations: [
        CarteComponent,
        CarteFamilyComponent,
        CarteMenusComponent,
        CarteFilterComponent,
        ProductComponent,
        MenuComponent,
        BestSalesComponent,
        BestOffersComponent
    ],
    exports: [

    ]
})

export class CarteModule {

}
